"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Whylawtransition() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section id="whylawtransition" className="relative overflow-hidden border-b border-border/50 bg-background py-24 text-foreground lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-20">
          <div ref={headingRef} className={`transition-all duration-700 ease-out lg:col-span-6 ${headingVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"} motion-reduce:translate-y-0 motion-reduce:opacity-100 motion-reduce:transition-none`}>
            <p className="mb-5 text-xs font-medium uppercase tracking-[0.28em] text-muted-foreground">
              Our Story
            </p>

            <h1 className="max-w-3xl font-serif text-4xl font-medium leading-[1.06] tracking-[-0.025em] text-primary md:text-5xl lg:text-[3.75rem]">
              A Practice Shaped by Experience, Attention, and Independent
              Judgment
            </h1>

            <div aria-hidden="true" className="mt-8 h-px w-16 bg-secondary" />
          </div>

          <div ref={contentRef} className={`flex flex-col justify-end transition-all delay-100 duration-700 ease-out lg:col-span-6 ${contentVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"} motion-reduce:translate-y-0 motion-reduce:opacity-100 motion-reduce:transition-none`}>
            <div className="max-w-2xl space-y-6 text-lg leading-8 text-foreground/80">
              <p>
                For more than four decades, Morrie I. Levine has approached
                legal work with a consistent commitment: listen carefully,
                examine the facts, communicate honestly, and apply independent
                judgment to the circumstances of each matter.
              </p>

              <p>
                Experience does not mean claiming to know every answer at the
                outset. It means recognizing what requires further
                investigation, which assumptions should be questioned, and
                when a different legal approach may deserve careful
                consideration.
              </p>
            </div>

            <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
              

              <a href="/ContactUsPage" className="inline-flex min-h-13 items-center justify-center rounded-sm bg-primary px-8 py-3.5 text-sm font-semibold text-primary-foreground transition-opacity duration-200 hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
                Request a Consultation
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}